<template lang="html">
  <div class="p-3">
    <div v-if="load">
      <b-form-group
        label="Adicionar nota"
        label-for="message">
        <b-form-textarea
          id="textarea"
          v-model="message"
          rows="3"
          max-rows="8"
        ></b-form-textarea>
      </b-form-group>
      <div class="text-right">
        <b-button variant="primary" class="mr-1" @click="sendMessage">Enviar</b-button>
      </div>
      <hr>
      <div v-for="note in notes" v-bind:key="note.id">
        <div class="message">
          <!--<div class="py-3 pb-5 mr-3 float-left">-->
            <!--<div class="avatar" v-if="note.profilePicture">-->
              <!--<img :src="note.profilePicture" class="img-avatar" alt="note.author">-->
              <!--<b-badge variant="info" class="avatar-status"></b-badge>-->
            <!--</div>-->
          <!--</div>-->
          <div>
            <small class="text-muted">{{ note.author }}</small>
            <small class="text-muted float-right mt-1" :title="note.dateCreated | moment-complete">{{ note.dateCreated | moment-short-date }}</small>
          </div>
          <!--<div class="text-truncate font-weight-bold">Lorem ipsum dolor sit amet</div>-->
          <div v-if="noteEditingId === note.id">
            <b-form-input v-model="note.message" :id="`note-edit-${note.id}`" @keydown.enter="updateNote(note)"></b-form-input>
          </div>
          <div v-else @click="setToEditing(note); setOldValue(note.message)">
            <small class="text-muted" id="oldValue">{{ note.message }} {{ note.dateCreated | moment-complete }}</small>
          </div>
        </div>
        <hr>
      </div>
    </div>
    <div v-else>
      É preciso selecionar uma transação para exibir as notas
    </div>
  </div>
</template>
<script>
export default {
  props: [],
  data () {
    return {
      message: '',
      notes: null,
      load: false,
      noteEditingId: '',
      oldMessage: ''
    }
  },
  mounted () {
    if (this.$route.params.txid) {
      this.getNotes(true)
    }
    this.$root.$on('loadNotes', () => {
      this.getNotes(true)
    })
  },
  methods: {
    setOldValue (value) {
      if (this.oldMessage === '') {
        this.oldMessage = value
      }
    },
    setToEditing (note) {
      this.noteEditingId = note.id
      setTimeout(() => {
        document.getElementById(`note-edit-${note.id}`).focus()
      }, 1)
    },
    updateNote (note) {
      let noteToUpdate = this.notes.find(n => n.id === note.id)
      noteToUpdate.message = note.message

      if (document.getElementById(`note-edit-${note.id}`).value === '') {
        document.getElementById('oldValue').innerHTML = this.message
      }

      if (noteToUpdate.message.length > 1) {
        this.$http.put(`api/transactions/${note.id}`, {message: noteToUpdate.message})
          .then(function (res) {
            this.$bvToast.toast('Anotação atualizada com sucesso', {
              autoHideDelay: 5000,
              variant: 'success'
            })
          })
          .catch(function (res) {
            document.getElementById('oldValue').innerHTML = this.oldMessage
            console.log('Error')
            console.log(res)
            this.$bvToast.toast('Você não tem permissão para atualizar esta anotação', {
              autoHideDelay: 5000,
              variant: 'danger'
            })
          })
      }
      this.noteEditingId = ''
    },
    getNotes (showLast) {
      this.load = false
      if (this.$route.params.txid) {
        this.load = true
        this.$http.get('api/transactions/' + this.$route.params.txid + '/notes')
          .then(function (res) {
            this.notes = res.data.list
            if (showLast && this.notes && this.notes.length > 0) {
              var ultimaNota = this.notes[0]
              this.$bvToast.toast(ultimaNota.message, {
                title: ultimaNota.author,
                autoHideDelay: 5000,
                variant: 'primary'
              })
            }
          })
          .catch(function (res) {
            console.log('Error')
            console.log(res)
          })
      }
    },
    sendMessage () {
      this.$http.post('api/transactions/' + this.$route.params.txid + '/notes', {message: this.message})
        .then(function (res) {
          this.message = ''
          this.getNotes(false)
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    }
  },
  watch: {
    '$route.params.txid' () {
      this.getNotes(true)
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/partial/note/TransactionNote.vue